import { render, staticRenderFns } from "./FilterChipsContainer.html?vue&type=template&id=cebe0680&scoped=true&"
import script from "./FilterChipsContainer.js?vue&type=script&lang=js&"
export * from "./FilterChipsContainer.js?vue&type=script&lang=js&"
import style0 from "./FilterChipsContainer.scss?vue&type=style&index=0&id=cebe0680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cebe0680",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VIcon,VMenu,VTabItem,VTextField})
